import {
    Dialog, DialogSurface, DialogTitle, DialogContent,
    DialogActions, DialogTrigger, DialogBody, Button, Spinner
} from "@fluentui/react-components";

/**
 * Confirmation dialog for cancelling an event AND refunding every registrant.
 * Distinct from plain delete: this moves money (account-balance credits) and
 * emails affected members, so the wording is explicit and it shows a result
 * summary after running.
 *
 * Props:
 *  - open, setOpen
 *  - eventName
 *  - busy            (bool)  request in flight
 *  - result          (obj|null) { counts:{refunded,skipped,failed} } or { error }
 *  - onConfirm       () => Promise  fires the cancel+refund
 */
function CancelRefundDialog(props) {
    const { open, setOpen, eventName, busy, result, onConfirm } = props;
    const counts = result && result.counts;

    return (
        <Dialog open={open} onOpenChange={(e, data) => { if (!busy) setOpen(data.open); }}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Cancel &amp; refund event</DialogTitle>
                    <DialogContent>
                        {!result && (
                            <>
                                You're about to cancel <strong>{eventName}</strong>.
                                <ul style={{ marginTop: 8, lineHeight: 1.6 }}>
                                    <li>Every attending registrant will be <strong>refunded to their WAREHOUSE account balance</strong> (already-refunded RSVPs are skipped).</li>
                                    <li>Each affected member will be <strong>emailed</strong> that the event was cancelled.</li>
                                    <li>The event is marked cancelled. This can't be undone.</li>
                                </ul>
                            </>
                        )}
                        {result && result.error && (
                            <div style={{ color: "#a3261b" }}>Something went wrong: {result.error}</div>
                        )}
                        {result && counts && (
                            <div style={{ lineHeight: 1.8 }}>
                                <div>✓ Refunded: <strong>{counts.refunded}</strong></div>
                                <div>Skipped (already refunded / not attending): <strong>{counts.skipped}</strong></div>
                                <div style={{ color: counts.failed ? "#a3261b" : undefined }}>Failed: <strong>{counts.failed}</strong></div>
                                {counts.failed > 0 && <div style={{ marginTop: 6, fontSize: 13 }}>Some refunds failed — check the function logs and retry; refunds are idempotent (won't double-refund).</div>}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        {!result && (
                            <>
                                <DialogTrigger disableButtonEnhancement>
                                    <Button appearance="secondary" disabled={busy}>Close</Button>
                                </DialogTrigger>
                                <Button appearance="primary" onClick={onConfirm} disabled={busy}>
                                    {busy ? <Spinner size="tiny" label="Cancelling…" /> : "Cancel event & refund all"}
                                </Button>
                            </>
                        )}
                        {result && (
                            <Button appearance="primary" onClick={() => setOpen(false)}>Done</Button>
                        )}
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}

export default CancelRefundDialog;
